import React from 'react'
import Page from 'component/page-container'
import { useParams } from 'react-router-dom'
import { nl2br } from 'helpers'

import './style.css'

/* global API */

const NewsListRoute = () => {
    const { processId = 0 } = useParams()
    const [ newsList, setNewsList ] = React.useState([])

    React.useEffect(() => {
        API.instance().news.getList(processId).then(setNewsList)
    }, [processId])

    return (
        <Page className="news-list-page" h1='Новости канала'>
            <div className="page__inner">
                {!!newsList.length ? (
                    <div className="news">
                        {newsList.map(news => (
                            <div key={news.id} className="news__item">
                                <div className="news__header">
                                    <div className="news__user">{news.user.name} {news.user.surname}</div>
                                    <div className="news__date">{news.createdAt}</div>
                                </div>
                                <div className="news__text" dangerouslySetInnerHTML={{__html: nl2br(news.text)}} />
                            </div>
                        ))}
                    </div>
                ) : 'Пустенько пока'}
            </div>
        </Page>
    )
}

export default NewsListRoute
